import IValidateCaminhaoDTO from '../entities/IValidateCaminhaoDTO'
import IValidateCaminhaoResponse from '../entities/IValidateCaminhaoResponse'
import { ILoteRepository } from '../repositories/ILoteRepository'

export interface IValidateCaminhao {
  execute(params: IValidateCaminhaoDTO): Promise<IValidateCaminhaoResponse>
}

export default class ValidateCaminhaoImpl implements IValidateCaminhao {
  constructor(private readonly lotesRepository: ILoteRepository) {}

  public async execute(
    params: IValidateCaminhaoDTO,
  ): Promise<IValidateCaminhaoResponse> {
    const response = await this.lotesRepository.validateCaminhao(params)
    return response
  }
}
